import { Component } from 'react';
import Select from 'react-select';

import './smart-select.css';

class SmartSelect extends Component {
  set(value) {
    const { config, on_change } = this.props;
    on_change(config.name, value);
  }

  update(e) {
    const { config } = this.props;

    if (config.multiple) {
      const newValues = e;
      this.set(newValues);
    } else {
      const newValue = e.target.value;
      this.set(newValue);
    }
  }

  printMultipleSelect() {
    const { config, value } = this.props;

    const options = config.options;

    const multipleSelectOptions = [];
    for (const index in options) {
      const currentOption = options[index];

      multipleSelectOptions.push({ value: currentOption.value, label: currentOption.label });
    }

    return <Select isMulti options={multipleSelectOptions} onChange={this.update.bind(this)} value={value} />;
  }

  printSelect() {
    const { config, value } = this.props;

    let selectClass = 'smart_select';

    const options = config.options;

    let actualOptions = [...options];
    if (!actualOptions) {
      actualOptions = [];
    }

    actualOptions.unshift({
      text: 'Select one',
      value: '',
    });

    if (config.wide) {
      selectClass += ' wide';
    }

    return (
      <select className={selectClass} value={value} onChange={this.update.bind(this)}>
        {actualOptions.map((option) => {
          return <option value={option.value}>{option.text}</option>;
        })}
      </select>
    );
  }

  render() {
    const { config } = this.props;

    const label = config.label ? config.label : false;

    let required = false;

    if (config.required) {
      required = true;
    }

    let containerClass = 'smart_input_container';

    if (config.wide) {
      containerClass += ' wide';
    }

    if (config.inline) {
      containerClass += ' inline';
    }

    if (config.centered) {
      containerClass += ' centered';
    }

    let multipleSelect = false;
    if (config.multiple) {
      multipleSelect = true;
    }

    if (label) {
      return (
        <div className={containerClass}>
          <label className="smart_input_label">
            {label}
            {required && (
              <span className="smart_input_required">
                <i className="fa fa-asterisk"></i>
              </span>
            )}
          </label>
          {!multipleSelect && this.printSelect()}
          {multipleSelect && this.printMultipleSelect()}
        </div>
      );
    }
  }
}

export default SmartSelect;
